import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";


export function authReducer(
  state = initialState.auth, action
  ) {
  switch(action.type) {
    case types.FETCH_AUTH_SUCCESS:
      return action.auth;
    default:
      return state;
  }
}

export function userSessionReducer(
  state = initialState.user, action
  ) {
  switch(action.type) {
    case types.FETCH_USER_SESSION_SUCCESS:
      return action.user;
    default:
      return state;
  }
}

export function updatingUserReducer(
  state = initialState.updatingUser, action
) {
  switch (action.type) {
    case types.FETCH_UPDATING_USER_SUCCESS:
        return action.updatingUser;
    default:
        return state;
  }
}

export function updatingUserHistoryRecordReducer(
  state = initialState.updateUserHistoryRecord, action
) {
  switch (action.type) {
    case types.UPDATE_USER_HISTORY_SUCCESS:
        return action.response;
    default:
      return state;
  }
}
